export default {
  apiKey: "AIzaSyCUNrj6Yw0_v3DD_W_gSyq6yy5-IGgt3Xw",
  authDomain: "gest-f73a4.firebaseapp.com",
  projectId: "gest-f73a4",
  storageBucket: "gest-f73a4.appspot.com",
  messagingSenderId: "547850842395",
  appId: "1:547850842395:web:6c48c538e3145f2567e3be",
};
